import { lender } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function getLenders({ url: { service: baseURL }, token }: IAPI) {
  return async function getLenders(country: string): Promise<lender.Lender[]> {
    const url = new URL(`/lender`, baseURL);
    url.searchParams.set('country', country);
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to fetch banks');
    }
  };
}
